import type { ReactNode } from 'react';
import { useUnit } from 'effector-react';
import { Button } from '@/components/ui/Button';
import { useGeolocation } from '@/hooks/useGeolocation';
import { $coordinate, $noCoordinates, setNoCoordinates } from '@/models/user';
import Layout from '@/pages/Layout';

export const GeolocationRoute = ({ children }: { children: ReactNode }) => {
  const coordinate = useUnit($coordinate);
  const noCoordinates = useUnit($noCoordinates);
  const { loading, error } = useGeolocation(!noCoordinates);
  const hasCoordinates = Boolean(coordinate.latitude && coordinate.longitude);

  if (noCoordinates || hasCoordinates) return <>{children}</>;

  if (loading) {
    return (
      <Layout>
        <div className="flex min-h-[calc(100dvh-7rem)] items-center justify-center text-center text-gray-600">
          Получаем данные о местоположении…
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="flex min-h-[calc(100dvh-7rem)] items-center justify-center">
        <section className="w-full max-w-xl bg-white px-6 py-10 text-center shadow-sm">
          <p role="alert" className="text-gray-700">
            Ошибка во время получения геоданных:{' '}
            {error || 'Информация о местоположении недоступна.'}
          </p>

          <a
            className="mt-8 inline-flex items-center gap-2 text-blue-700 underline"
            target="_blank"
            href="/setup_geo.pdf"
            rel="noopener noreferrer"
          >
            <span
              aria-hidden="true"
              className="h-0 w-0 shrink-0 border-y-[6px] border-y-transparent border-l-[9px] border-l-blue-700"
            />
            Как настроить доступ к геолокации
          </a>

          <p className="mt-7 text-gray-700">
            В случае возникновения проблем предоставления доступа обратитесь в СервисДеск компании.
          </p>

          <div className="mt-7 flex justify-center">
            <Button onClick={() => setNoCoordinates(true)}>Регистрация без учета гео данных</Button>
          </div>
        </section>
      </div>
    </Layout>
  );
};
